import {
    Typography,
    Grid,
    TextField,
    Alert,
    Chip,
} from '@mui/material';
import { FormikProps } from 'formik';
import { CustomerTypes } from '../../../../../types';
import { SettingsFieldCard } from './settings-field-card';

interface Props {
    formik: FormikProps<CustomerTypes.OnboardingForm>;
}

export const SsoSettingsTab: React.FC<Props> = ({ formik }) => {
    const { values } = formik;

    const ssoConfig = values?.ssoConfig ?? { active: false, clientId: '', ssoUrl: '' };
    const isSsoActive = ssoConfig.active;

    return (
        <>
            <Typography fontWeight={500} fontSize={18} mt={2}>
                Single Sign-On (SSO)
            </Typography>
            <Typography fontSize={14} mb={1} color="text.secondary">
                View the current SSO configuration for this organization. SSO is configured during customer onboarding.
            </Typography>

            <Alert severity="info" sx={{ mb: 2 }}>
                SSO settings are read-only. To configure or modify SSO, update the customer's onboarding invitation.
            </Alert>

            {/* SSO Status */}
            <SettingsFieldCard>
                <Grid maxWidth="sm" sx={{ width: 1 }}>
                    <Typography fontWeight="600" fontSize={16}>
                        SSO Status
                    </Typography>
                    <Typography color="textSecondary" variant="body2" mb={1}>
                        Whether Single Sign-On authentication is active for this organization.
                    </Typography>
                    <Chip
                        label={isSsoActive ? 'Enabled' : 'Disabled'}
                        color={isSsoActive ? 'success' : 'default'}
                        size="small"
                    />
                </Grid>
            </SettingsFieldCard>

            {/* SSO Client ID */}
            <SettingsFieldCard>
                <Grid maxWidth="sm" sx={{ width: 1 }}>
                    <Typography fontWeight="600" fontSize={16}>SSO Client ID</Typography>
                    <Typography color="textSecondary" variant="body2" mb={1}>
                        The OAuth Client ID provided by the organization's identity provider.
                    </Typography>
                    <TextField
                        fullWidth
                        size="medium"
                        placeholder="Not configured"
                        value={ssoConfig.clientId || ''}
                        disabled
                        InputProps={{ readOnly: true }}
                    />
                </Grid>
            </SettingsFieldCard>

            {/* SSO URL */}
            <SettingsFieldCard>
                <Grid maxWidth="sm" sx={{ width: 1 }}>
                    <Typography fontWeight="600" fontSize={16}>SSO URL</Typography>
                    <Typography color="textSecondary" variant="body2" mb={1}>
                        The SSO login URL endpoint for the organization's identity provider.
                    </Typography>
                    <TextField
                        fullWidth
                        size="medium"
                        placeholder="Not configured"
                        value={ssoConfig.ssoUrl || ''}
                        disabled
                        InputProps={{ readOnly: true }}
                    />
                </Grid>
            </SettingsFieldCard>
        </>
    );
};
